import enUS from 'date-fns/locale/en-US';

import { LOCALE_DATA } from 'state/intl/constants';

/** Resolve the shared date formatting locale, retaining the en-US fallback. */
export const localeStringToDateFnsLocale = (locale: string) =>
  LOCALE_DATA[locale as keyof typeof LOCALE_DATA]?.dateFormat || enUS;
